/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { SVBHeader, SVBHeaderMobile } from '@svb/portal-ui-react-components';
import SVBSearchUI from '../../search';
// import { handleTopMenuConfig, closeAllMenus } from './helper/SVBHeaderSubMenuAction';
import { useStore } from '../../../core/useStore';
import { getMenuItem, sideMenu } from '../../../helpers/sidemenu';
import { getWindowSize } from '../../../core/getWindowSize';
import SearchDataProvider from '../../search/searchHelpers/service/SearchDataProvider';
import RebrandedNavHeader from './RebrandedNavHeader';

export default function SVBPortalHeader(props) {
  const { headerContent, logo } = props;
  const [selectedMenuItem, setSelectedMenuItem] = useState('');
  const [headerMenu, setHeaderMenu] = useState(headerContent || []);
  const location = useLocation();
  const cWindowSize = getWindowSize();
  const defaultCatalogItems = useStore((state) => state.defaultCatalogItems);
  const menu = useStore((state) => state.apiSideMenu);
  const [searchParams] = useSearchParams();
  const baseUrl = window.location.host;
  const cpath = useParams();
  // commenting out search from nav
  const [show, setShow] = useState(false);
  const showSearchModal = (e) => {
    e.preventDefault();
    setShow(true);
  };

  const hideSearchModal = () => {
    setShow(false);
  };

  // const findLocationPathforHighlight = async () => {
  //   const path = `/${cpath.folder ? cpath.folder : ''}${
  //     cpath.folderTwo ? `/${cpath.folderTwo}` : ''
  //   }${cpath.folderThree ? `/${cpath.folderThree}` : ''}${
  //     cpath.folderFour ? `/${cpath.folderFour}` : ''
  //   }${cpath.folderFive ? `/${cpath.folderFive}` : ''}${cpath.id ? `/${cpath.id}` : ''}${
  //     searchParams.get('method') && searchParams.get('path')
  //       ? `?path=${searchParams.get('path')}&method=${searchParams.get('method')}`
  //       : searchParams.get('path')
  //       ? `?path=${searchParams.get('path')}`
  //       : searchParams.get('method')
  //       ? `?method=${searchParams.get('method')}`
  //       : ''
  //   }`;
  //   const item = await getMenuItem(path, menu);
  //   setSelectedMenuItem(item);
  // };

  // useEffect(() => {
  //   handleTopMenuConfig();
  // }, []);

  // useEffect(() => {
  //   const filteredMenuItems = defaultCatalogItems;
  //   sideMenu(filteredMenuItems, true);
  // }, [defaultCatalogItems]);

  useEffect(() => {
    if (show) {
      //hide modal on route navigation
      hideSearchModal();
    }
    // findLocationPathforHighlight();
  }, [location]);

  // useEffect(() => {
  //   if (menu?.length > 0) {
  //     let newHeaderMenu = headerMenu;
  //     if (newHeaderMenu[0]?.subMenu) {
  //       newHeaderMenu[0].subMenu = menu;
  //       setHeaderMenu(newHeaderMenu);
  //     }
  //   }
  // }, [menu]);
  return (
    <>
      <header
        className='fixed-top'
        onBlur={(e) => {
          e.preventDefault();
          if (e.relatedTarget === null) {
            // closeAllMenus();
          }
        }}
      >
        {cWindowSize.width > 768 ? (
          // <SVBHeader
          //   headerContent={headerMenu}
          //   logo={logo}
          //   showSearch={process.env.REACT_APP_GLOBAL_SEARCH === 'true'}
          //   selectedMenuItem={selectedMenuItem}
          //   onSearchClick={showSearchModal}
          //   external={true}
          // />
          <RebrandedNavHeader
            menus={headerMenu}
            logo={logo}
            showSearch={process.env.REACT_APP_GLOBAL_SEARCH === 'true'}
            onSearchClick={showSearchModal}
          />
        ) : (
          <SVBHeaderMobile
            headerContent={headerMenu}
            logo={logo}
            showSearch={process.env.REACT_APP_GLOBAL_SEARCH === 'true'}
            selectedMenuItem={selectedMenuItem}
            onSearchClick={showSearchModal}
            external={true}
            menu={menu}
          />
        )}
      </header>
      {show && (
        <SearchDataProvider>
          <SVBSearchUI show={show} hideSearchModal={hideSearchModal} />
        </SearchDataProvider>
      )}
    </>
  );
}
